import script from "./BookingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingPage.vue?vue&type=script&setup=true&lang=js"

import "./BookingPage.vue?vue&type=style&index=0&id=202c54d3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-202c54d3"]])

export default __exports__